"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importWarehouseExcel = exports.ExportExcelType = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _fileSaver = require("file-saver");
var Excel = _interopRequireWildcard(require("exceljs"));
var _index = require("@/utils/index");
var _string = require("@/utils/string");
var _lodash = require("lodash");
var ExportExcelType;
(function (ExportExcelType) {
  ExportExcelType["RealPublish"] = "REAL_PUBLISH";
  ExportExcelType["RealNoPublish"] = "REAL_NO_PUBLISH";
})(ExportExcelType || (exports.ExportExcelType = ExportExcelType = {}));
var fontBold = {
  font: {
    bold: true
  }
};
var fontBoldRed = {
  font: {
    bold: true,
    color: {
      argb: "ffff0202"
    }
  }
};
var fontBoldGreen = {
  font: {
    bold: true,
    color: {
      argb: "ff427c27"
    }
  }
};
var border = {
  top: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  left: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  bottom: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  right: {
    style: "thin",
    color: {
      argb: "#000"
    }
  }
};
var row = 0;
var importWarehouseExcel = exports.importWarehouseExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, type, fileName, workbook, worksheet, startTableRow, startTable, dataFilter, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data, type = _ref.type;
          // config export excel
          fileName = "Import warehouse ".concat(type);
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Import", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2
            }]
          }); //add table
          startTableRow = 1;
          startTable = worksheet.getCell("A".concat(startTableRow++));
          startTable.style = {
            font: {
              color: {
                argb: "ffff0202"
              }
            }
          };
          dataFilter = [];
          if (type == ExportExcelType.RealPublish) {
            dataFilter = data.filter(function (e) {
              return e.item.isPublished;
            });
          } else if (type == ExportExcelType.RealNoPublish) {
            dataFilter = data.filter(function (e) {
              return !e.item.isPublished;
            });
          } else if (type == '') {
            dataFilter = data;
          }
          generateTable(worksheet, dataFilter, startTableRow);
          _context.next = 12;
          return workbook.xlsx.writeBuffer();
        case 12:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function importWarehouseExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var generateTable = function generateTable(worksheet, data, startTableRow) {
  //transform data
  var report = [];
  data.forEach(function (e) {
    e.importWarehouseDetails.forEach(function (detail) {
      var temp = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, detail), e), {}, {
        lotQuantity: detail.quantity,
        rowspan: 0
      });
      report.push(temp);
    });
    if ((0, _lodash.isEmpty)(e.importWarehouseDetails)) {
      report.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
        rowspan: 0,
        lotQuantity: '--',
        lotNumber: '--'
      }));
    }
  });
  var count = 0;
  report.forEach(function (element, index) {
    count++;
    if (index < report.length - 1 && element.product.id != report[index + 1].product.id) {
      report[index + 1 - count].rowspan = count;
      count = 0;
    }
  });
  if (report.length) {
    report[report.length - count].rowspan = count;
  }
  report = (0, _lodash.orderBy)(report, ['product.isPublished', 'product.id', 'date'], ['desc', 'asc', 'asc']);
  var startRow = startTableRow;
  var dataExcel = [{
    value: "Product",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "product.name",
    width: 20,
    mergeRow: true
  }, {
    value: "Lot No",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "lotNumber",
    width: 20,
    mergeRow: true
  }, {
    value: "Quantity",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'lotQuantity',
    numFmt: '#,##0',
    width: 12,
    mergeRow: true
  }, {
    value: "Expired",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "expired",
    format: 'date',
    width: 12,
    mergeRow: true
  }, {
    value: "Import Date",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "date",
    format: 'date',
    width: 12,
    mergeRow: true
  }, {
    value: "Code",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "code",
    width: 20,
    mergeRow: true
  }, {
    value: "Staff",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "staff.name",
    width: 12,
    mergeRow: true
  }, {
    value: "Note",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "note",
    width: 12,
    mergeRow: true
  }];
  var char = "A";
  dataExcel.forEach(function (element) {
    var style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    worksheet.getCell("".concat(char).concat(startRow)).style = style;
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    worksheet.getRow(startRow).height = 50;
    row = startRow + 1;
    report.forEach(function (order, index) {
      var rowIndex = startRow + index + 1;
      worksheet.getRow(rowIndex).height = 50;
      worksheet.getCell("".concat(char).concat(rowIndex)).style = {
        border: border,
        alignment: {
          wrapText: true,
          vertical: 'middle'
        }
      };
      element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
      var value = (0, _index.generateProp)(order, element.prop, element.format);
      // if (element.mergeRow && order.rowspan) {
      //   worksheet.mergeCells(`${char}${rowIndex}:${char}${rowIndex - 1 + order.rowspan}`);
      // }
      worksheet.getCell("".concat(char).concat(rowIndex)).value = value;
      row = rowIndex;
    });
    char = (0, _string.nextChar)(char);
  });
  worksheet.columns.forEach(function (e, i) {
    if (dataExcel[i]) e.width = dataExcel[i].width;
  });
};